import { FiTruck, FiAward, FiEdit3, FiMaximize } from "react-icons/fi";
import styles from "../../styles/home.module.css";

const FEATURES = [
  { icon: <FiTruck />, text: <>تغليف وتوصيل<br />آمن وسريع</> },
  { icon: <FiAward />, text: <>خامات فاخرة وطباعة<br />عالية الجودة مع ضمان</> },
  { icon: <FiEdit3 />, text: <>تصميم خاص مع<br />دعم ومتابعة</> },
  { icon: <FiMaximize />, text: <>تحديد المقاس<br />المناسب لبيتك</> },
];

const FeatureBar = () => {
  return (
    <div className={styles.featureBarWrap}>
      <div className={styles.featureBar}>
        {FEATURES.map((f, i) => (
          <div key={i} className={styles.featureItem}>
            {f.icon}
            <span>{f.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureBar;
